// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `   .contain {
    display: flex;
    flex-direction: column;
    height: 100vh;
   
  }
  
  .main-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 100%;
    margin-top: 50px;
  }
  
  .form-containerOne {
    max-width: 600px;
    margin: auto;
    background-color: #f9f9f9;
    /* padding: 20px; */
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .AddOneToOne {
    text-align: center;
  }
  
  .form-group1 {
    margin-bottom: 15px;
    width: 300px;
  }
  
  .form-group1 label {
    display: block;
    margin-bottom: 5px;
  }
  
  .form-group1 input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
  }
  
  .btnOne {
    padding: 10px;
    width: 200px;
    margin: 10px 0px 0px 50px;
    background-color: #2865aa;
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .form-group11 {
    height: 40px;
    margin-bottom: 15px;
    width: 300px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
  }
  
  /* ---------------------------------- */
  /* ✅ Mobile View Fix Starts Here     */
  /* ---------------------------------- */
  @media (max-width: 768px) {
    .contain {
      display: block;
      height: auto; 
    }
    
  .form-containerOne {
    max-width: 600px;
    margin:20px;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  
    .main-content {
      display: block;
      height: auto;
      overflow-y: unset;
    }
  
    .form-containerOne {
      margin: 20px auto; 
    }
  
    .form-group1 input,
    .form-group11 {
      padding: 10px;
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 5px;
    }
  
    .btnOne {
      padding: 10px;
      width: 200px;
      margin: 10px 0px 0px 50px;
      background-color: #2865aa;
      border: none;
      color: white;
      cursor: pointer;
      border-radius: 5px;
    }
  
    .AddOneToOne {
      display: none;
    }
  
    .form-group11 {
      height: 40px;
      margin-bottom: 15px;
      width: 300px;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      box-sizing: border-box;
    }
  
    .form-group111 {
      height: 40px;
      margin-bottom: 15px;
      width: 500px;
      width: 100%;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/fees.css"],"names":[],"mappings":"GAAG;IACC,aAAa;IACb,sBAAsB;IACtB,aAAa;;EAEf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,uCAAuC;EACvC,sCAAsC;EACtC,uCAAuC;EACvC;IACE;MACE,cAAc;MACd,YAAY;IACd;;EAEF;IACE,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;EACzC;;;IAGE;MACE,cAAc;MACd,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;;MAEE,aAAa;MACb,WAAW;MACX,sBAAsB;MACtB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,yBAAyB;MACzB,yBAAyB;MACzB,YAAY;MACZ,YAAY;MACZ,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,YAAY;MACZ,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,sBAAsB;IACxB;;IAEA;MACE,YAAY;MACZ,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,sBAAsB;IACxB;EACF","sourcesContent":["   .contain {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n   \n  }\n  \n  .main-content {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    width: 100%;\n    margin-top: 50px;\n  }\n  \n  .form-containerOne {\n    max-width: 600px;\n    margin: auto;\n    background-color: #f9f9f9;\n    /* padding: 20px; */\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .AddOneToOne {\n    text-align: center;\n  }\n  \n  .form-group1 {\n    margin-bottom: 15px;\n    width: 300px;\n  }\n  \n  .form-group1 label {\n    display: block;\n    margin-bottom: 5px;\n  }\n  \n  .form-group1 input {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-sizing: border-box;\n  }\n  \n  .btnOne {\n    padding: 10px;\n    width: 200px;\n    margin: 10px 0px 0px 50px;\n    background-color: #2865aa;\n    border: none;\n    color: white;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  \n  .form-group11 {\n    height: 40px;\n    margin-bottom: 15px;\n    width: 300px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-sizing: border-box;\n  }\n  \n  /* ---------------------------------- */\n  /* ✅ Mobile View Fix Starts Here     */\n  /* ---------------------------------- */\n  @media (max-width: 768px) {\n    .contain {\n      display: block;\n      height: auto; \n    }\n    \n  .form-containerOne {\n    max-width: 600px;\n    margin:20px;\n    background-color: #f9f9f9;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  \n    .main-content {\n      display: block;\n      height: auto;\n      overflow-y: unset;\n    }\n  \n    .form-containerOne {\n      margin: 20px auto; \n    }\n  \n    .form-group1 input,\n    .form-group11 {\n      padding: 10px;\n      width: 100%;\n      border: 1px solid #ccc;\n      border-radius: 5px;\n    }\n  \n    .btnOne {\n      padding: 10px;\n      width: 200px;\n      margin: 10px 0px 0px 50px;\n      background-color: #2865aa;\n      border: none;\n      color: white;\n      cursor: pointer;\n      border-radius: 5px;\n    }\n  \n    .AddOneToOne {\n      display: none;\n    }\n  \n    .form-group11 {\n      height: 40px;\n      margin-bottom: 15px;\n      width: 300px;\n      padding: 10px;\n      border: 1px solid #ccc;\n      border-radius: 5px;\n      box-sizing: border-box;\n    }\n  \n    .form-group111 {\n      height: 40px;\n      margin-bottom: 15px;\n      width: 500px;\n      width: 100%;\n      padding: 10px;\n      border: 1px solid #ccc;\n      border-radius: 5px;\n      box-sizing: border-box;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
